import { create } from "zustand";
import { authenticatedAxios, baseURL } from "../../apis";

const useAdsList = create((set, get) => ({
  ads: [],
  loaded: false,
  filters: {
    page: 1,
    size: 10,
    search: "",
    slot_location: "",
    is_active: "",
    sort_by: "start_date", // Nilai default untuk sorting
    order: "desc", // Nilai default untuk urutan
  },
  actions: {
    setAds: (payload) => {
      set(() => ({ ads: payload }));
    },
    setFilters: (newFilters) => {
      set((state) => ({
        filters: { ...state.filters, ...newFilters },
      }));
    },
    getAds: async (newFilters = {}) => {
      set({ loaded: false });
      const currentFilters = get().filters;

      // Gabungkan filter lama dengan yang baru (jika ada)
      const updatedFilters = {
        ...currentFilters,
        ...newFilters,
        page: newFilters.page || 1,
      };
      get().actions.setFilters(updatedFilters);

      // Siapkan params untuk request, hapus properti yang nilainya kosong
      const params = {};
      for (const [key, value] of Object.entries(updatedFilters)) {
        if (value !== "" && value !== null) {
          params[key] = value;
        }
      }

      try {
        const { data } = await authenticatedAxios.get(
          `${baseURL}/api/admin/ads/banners/`,
          { params } // Kirim params ke axios
        );

        // Asumsi API mengembalikan array, sesuaikan jika struktur data berbeda (misal: { results: [...] })
        set({ ads: data });
        console.log("Berhasil get ads = " + data.length);
        console.log(data);
      } catch (err) {
        console.log(err);
      } finally {
        set({ loaded: true });
      }
    },
    addAd: async (adData) => {
      console.log(adData.image);
      const { getAds } = get().actions;

      const formData = new FormData();
      formData.append("title", adData.title);
      formData.append("target_url", adData.targetUrl);
      formData.append("slot_location", adData.slotLocation);
      formData.append("start_date", adData.startDate);
      formData.append("end_date", adData.endDate);
      formData.append("is_active", adData.isActive);

      // --- PERBAIKAN DI SINI ---
      // Cek jika adData.image adalah objek File yang valid sebelum ditambahkan.
      if (adData.image instanceof File) {
        formData.append("image", adData.image);
      }

      try {
        await authenticatedAxios.post(
          `${baseURL}/api/admin/ads/banners/create/`,
          formData
        );

        console.log("Banner baru berhasil dibuat.");
        await getAds();
        return { success: true };
      } catch (err) {
        console.error(
          "Gagal membuat banner baru:",
          err.response?.data || err.message
        );
        return {
          success: false,
          error: err.response?.data || "An unknown error occurred.",
        };
      }
    },
    updateAd: async (bannerId, adData) => {
      const { getAds } = get().actions;
      const formData = new FormData();

      formData.append("title", adData.title);
      formData.append("target_url", adData.targetUrl);
      formData.append("slot_location", adData.slotLocation);
      formData.append("start_date", adData.startDate);
      formData.append("end_date", adData.endDate);
      formData.append("is_active", adData.isActive);

      if (adData.image instanceof File) {
        formData.append("image", adData.image);
      }

      try {
        // Menggunakan metode PUT untuk mengirim data yang diperbarui
        await authenticatedAxios.put(
          `${baseURL}/api/admin/ads/banners/${bannerId}/update/`,
          formData
        );
        console.log(`Banner dengan ID ${bannerId} berhasil diupdate.`);
        await getAds(); // Refresh list setelah berhasil update
        return { success: true };
      } catch (err) {
        console.error(
          `Gagal mengupdate banner dengan ID ${bannerId}:`,
          err.response?.data || err.message
        );
        return {
          success: false,
          error: err.response?.data || "An unknown error occurred.",
        };
      }
    },
    deleteAd: async (bannerId) => {
      const { getAds } = get().actions;
      try {
        await authenticatedAxios.delete(
          `${baseURL}/api/admin/ads/banners/${bannerId}/delete/`
        );
        console.log(`Banner dengan ID ${bannerId} berhasil dihapus.`);
        await getAds(); // Refresh list setelah menghapus
        return { success: true };
      } catch (err) {
        console.error(
          `Gagal menghapus banner dengan ID ${bannerId}:`,
          err.response?.data || err.message
        );
        return {
          success: false,
          error: err.response?.data || "An unknown error occurred.",
        };
      }
    },
    toggleAdStatus: async (bannerId) => {
      const { getAds } = get().actions;
      try {
        // Mengirim request POST sesuai spesifikasi endpoint
        await authenticatedAxios.post(
          `${baseURL}/api/admin/ads/banners/${bannerId}/toggle-status/`
        );

        console.log(`Status untuk banner ID ${bannerId} berhasil diubah.`);

        // Ambil data terbaru untuk me-refresh tampilan
        await getAds();

        return { success: true };
      } catch (err) {
        console.error(
          `Gagal mengubah status untuk banner ID ${bannerId}:`,
          err.response?.data || err.message
        );
        return {
          success: false,
          error: err.response?.data || "An unknown error occurred.",
        };
      }
    },
  },
}));

export default useAdsList;
